import React, { useCallback, useContext, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { filesize } from "filesize";

import { ContextApi } from "../../context/contextApi";

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import styles from './style.module.scss'

export function Upload({
  setImageB64,
  labelUploadImage,
  allTypesImage,
  imgDefault,
  idCamDefault,
  setInfoPrincipais,
  setInfoAvancadas
}) {
  const [styleDropZone, setStyleDropZone] = useState();
  const [files, setFiles] = useState([]);
  const [typeImages, setTypeImages] = useState(null);
  const { 
    deletarImagem,
} = useContext(ContextApi);

 function checkAccept() {
  switch (allTypesImage) {
    case true:
      setTypeImages({
        'image/jpeg': ['.jpeg', '.png', '.jpg'],
        'image/png': ['.png']
      });
      break;
    case false:
      setTypeImages({'image/png': ['.png']});
      break;
    default:
      break;
  }
 }

 function handleDeleteImage(idCam, nameTagImage) {
  deletarImagem(idCam, nameTagImage);
  setInfoPrincipais(true)
  setInfoAvancadas(false)
}


function checkStayleDrop() {
  if (isDragAccept) {
    setStyleDropZone(styles.dragActive);
  } else if (isDragReject) {
    setStyleDropZone(styles.dragReject);
  } else {
    setStyleDropZone(styles.dropContainer);
  }
}

 const {
   getRootProps,
   getInputProps,
   isDragActive,
   isDragReject,
   isDragAccept,
   acceptedFiles,
 } = useDropzone({
  accept: typeImages,
  onDrop: acceptedFiles => {
    setFiles(acceptedFiles.map(file => Object.assign(file, {
      preview: URL.createObjectURL(file)
    })));
    getBase64(acceptedFiles[0])
  }
 });

 function getBase64(data) {
  var reader = new FileReader();
  reader.readAsDataURL(data);
  reader.onload = function () {
    setImageB64(reader.result);
  };
  reader.onerror = function (error) {
    console.log('Error: ', error);
  };
}

const thumbs = files.map(file => (
  <div>
    <div className={styles.thumb} key={file.name}>
        <div className={styles.thumbInner}>
          <img
            src={file.preview}
            className={styles.img}
            // Revoke data uri after image is loaded
            onLoad={() => { URL.revokeObjectURL(file.preview) }}
          />
        </div>
    </div>
    <span className={styles.descriptionThumb}>{file.path.slice(0, 40)}{file.path.length >= 40 ? '...' : ''} - Size: {filesize(file.size)}</span>
  </div>
));

const ThumbsDefault = () => (
  <div className={styles.boxThumbDefault}>
    <div className={styles.thumb} key={imgDefault}>
        <div className={styles.thumbInner}>
          <img
            src={`https://surfview.com.br/staging/${imgDefault}`}
            className={styles.img}
          />
        </div>
    </div>
    <span className={styles.descriptionThumb}>{imgDefault}</span>
    <DeleteForeverIcon 
    onClick={() => handleDeleteImage(idCamDefault.id, idCamDefault.tagName)}
    />
  </div>
);
 
 const renderDragMessage = useCallback(() => {
   if (!isDragActive) {
     return (
      <div className={styles.boxMsgUploa}>
        <p className={styles.UploadMessage}>Arraste e solte as imagens aqui...</p>
        <em>{!allTypesImage ? 'Apenas imagens em formato .png' : 'Imagens em formato (.jpg, .jpeg, .png)'}</em>
      </div>
     );
   }
   if (isDragReject) {
     return (
       <p
       type="error"
       className={styles.UploadMessageError}
       >
         Tipo de arquivo não suportado
       </p>
     );
   }
   return <p className={styles.UploadMessageSucess} type="success">Solte as imagens aqui</p>;
 }, [isDragActive, isDragReject, isDragAccept]);

 useEffect(() => {
  checkStayleDrop()
 })

 useEffect(() => {
  // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
  checkAccept()
  return () => files.forEach(file => URL.revokeObjectURL(file.preview));
}, []);

 return (
  <div className={styles.boxUpload}>
   <label className={styles.labelUpload}>{labelUploadImage}</label>
   <div className={styleDropZone} {...getRootProps()}>
     <input {...getInputProps()} />
     {renderDragMessage()}
   </div>
    <aside>
      {thumbs}
      {imgDefault && files.length === 0 && <ThumbsDefault />}
    </aside>
  </div>
 )
}
